__turbopack_context__.v({
  "arc": "public-loading-module__BUsY0W__arc",
  "public-spin": "public-loading-module__BUsY0W__public-spin",
  "region": "public-loading-module__BUsY0W__region",
  "spinner": "public-loading-module__BUsY0W__spinner",
  "track": "public-loading-module__BUsY0W__track",
});
